/**
 * Created by vladislav on 05.03.2020
 */

cleverapps.UI.Button = cc.Node.extend({
    ctor: function (settings) {
        this._super();

        this.setAnchorPoint(0.5, 0.5);

        this.settings = settings;

        if (!settings.type && cleverapps.environment.isEditorScene()) {
            settings.type = cleverapps.styles.UI.Button.Images.editor;
        }

        if (!settings.textVariant && cleverapps.environment.isEditorScene()) {
            settings.textVariant = "strict";
        }

        if (!settings.type || !settings.type.button_png) {
            settings.type = cleverapps.styles.UI.Button.Images.button_green;
        }

        this.bright = true;
        this.createBackground();

        if (settings.text || settings.textOff) {
            this.font = this.workFont(settings.textVariant || settings.type.textVariant);
        }

        if (settings.text && settings.type.widthByContent) {
            settings.content = this.createText(settings.text, settings);

            const padding = this.calcPadding();
            const width = Math.min(settings.content.width + padding.left + padding.right, 0.9 * cleverapps.resolution.getSceneSize().width);
            this.resize(width, settings.content.height);

            delete settings.text;
        }

        this.content = settings.content;
        this.contentOff = settings.contentOff;

        const innerRect = this.calcInnerRect();

        [this.content, this.contentOff].forEach((content) => {
            if (content) {
                cleverapps.UI.fitToBox(content, {
                    width: innerRect.width,
                    height: innerRect.height
                });
            }
        }, this);

        if (settings.text) {
            this.content = this.createText(settings.text, settings, innerRect);
        }

        if (settings.textOff) {
            this.contentOff = this.createText(settings.textOff, settings, innerRect);
        }

        [this.content, this.contentOff].forEach(function (content) {
            if (content) {
                this.addChild(content);

                content.setPosition(innerRect.x + innerRect.width / 2, innerRect.y + innerRect.height / 2);
            }
        }, this);

        this._toggleContent(true);

        if (this.content instanceof cleverapps.UI.LabelTTF) {
            this.text = this.content;
        }

        if (this.contentOff instanceof cleverapps.UI.LabelTTF) {
            this.textOff = this.contentOff;
        }

        this.setCascadeOpacityEnabledRecursively(true);

        this.hoverHandler = cleverapps.UI.applyHover(this, {
            filter: settings.filter,
            interactiveScale: false,
            onMouseOver: this.onMouseOver.bind(this),
            onMouseOut: this.onMouseOut.bind(this)
        });

        this.clickHandler = cleverapps.UI.onClick(this, () => {
            this.action();
        }, {
            filter: settings.filter,
            interactiveScale: false,
            onStatePressed: this.onStatePressed.bind(this),
            onStateReleased: this.onStateReleased.bind(this)
        });

        if (settings.mark) {
            this.setAttention(true);
        }

        if (settings.disabled) {
            this.disable();
        }
    },

    setAttention: function (attention) {
        if (attention && this.mark) {
            return;
        }

        if (!attention) {
            if (this.mark) {
                this.mark.removeFromParent();
                delete this.mark;
            }

            return;
        }

        this.mark = new Attention();
        this.mark.setAlignment(this.settings.type.mark || cleverapps.styles.UI.Button.mark);
        this.addChild(this.mark);
    },

    calcInnerRect: function () {
        const padding = this.calcPadding();
        return cc.rect(padding.left, padding.bottom, this.width - padding.left - padding.right, this.height - padding.bottom - padding.top);
    },

    calcPadding: function () {
        const padding = this.settings.type.SKIP_RESOLUTION ? this.settings.type.SKIP_RESOLUTION.padding : cleverapps.styles.UI.Button.SKIP_RESOLUTION.padding;

        return {
            left: Math.floor(this.height * padding.left),
            right: Math.floor(this.height * padding.right),
            bottom: Math.floor(this.height * padding.bottom),
            top: Math.floor(this.height * padding.top)
        };
    },

    createText: function (string, settings, rect) {
        if (TextWithIcon.IsApplicable(string, settings.icons)) {
            return new TextWithIcon(string, {
                font: this.font,
                width: rect && rect.width,
                height: rect && rect.height,
                icons: settings.icons,
                iconScale: settings.iconScale
            });
        }
        const text = cleverapps.UI.generateOnlyText(string, this.font);
        if (rect) {
            text.fitTo(rect.width, rect.height);
        }

        return text;
    },

    guessFontSize: function () {
        const styles = cleverapps.styles.UI.Button;

        const size = Math.round(this.height * cleverapps.styles.FONTS.BUTTON_TEXT.size / styles.defaultSize);

        return Math.min(this.settings.type.maxFontSize || styles.maxFontSize, size);
    },

    showAlert: function () {
        if (!this.disabled && this.settings.spine && this.background.hasAnimation("alert")) {
            this.background.addAnimation(0, "alert", false);
        }
    },

    setMarkVisible: function (visible) {
        if (this.mark) {
            this.mark.setVisible(visible);
        }
    },

    showHint: function (hintText) {
        const action = new cc.Sequence(
            new cc.DelayTime(1),
            new cc.CallFunc(() => {
                if (this.isDisplayed() && !this.hint) {
                    this.hint = new cleverapps.UI.Tooltip(this.background, {
                        text: hintText,
                        size: cleverapps.styles.UI.Button.tooltipSize,
                        location: this.settings.hintLocation
                    });
                    cleverapps.Scenes.GetMovingNode(this).addChild(this.hint);
                }
            })
        );

        action.setTag(cleverapps.UI.Button.HINT_ACTION_TAG);
        this.runAction(action);
    },

    hideHint: function () {
        this.stopActionByTag(cleverapps.UI.Button.HINT_ACTION_TAG);

        if (this.hint) {
            this.hint.removeFromParent();
            this.hint = undefined;
        }
    },

    createBackground: function () {
        if (this.settings.noBg) {
            this.setContentSize2(this.settings.width, this.settings.height);
            return;
        }

        let width;
        let height;
        let background;

        if (this.settings.spine) {
            width = this.settings.width;
            height = this.settings.height;
            background = new cleverapps.Spine(this.settings.spine);
            if (this.settings.skin) {
                background.setSkin(this.settings.skin);
            }
            background.setAnimation(0, "idle", true);
        } else {
            background = cleverapps.UI.createScale9Sprite(this.settings.type.button_png, this.settings.scale9Rect !== undefined ? this.settings.scale9Rect : cleverapps.UI.Scale9Rect.TwoPixelX);
            width = this.settings.width || background.width;
            height = this.settings.height || background.height;
        }

        this.background = background;
        this.addChild(background);
        this.resize(width, height);
    },

    workFont: function (textVariant) {
        const font = cleverapps.clone(cleverapps.UI.Button.WorkFont(textVariant));

        const size = this.guessFontSize();
        if (size) {
            font.size = size;
        }

        return font;
    },

    setString: function (string) {
        this._setString(this.content, this.text, string);
    },

    setStringOff: function (string) {
        this._setString(this.contentOff, this.textOff, string);
    },

    _setString: function (content, text, string) {
        const innerRect = this.calcInnerRect();

        if (content instanceof TextWithIcon) {
            content.fitToSize = { width: innerRect.width, height: innerRect.height };
            content.setString(string);
        } else if (TextWithIcon.IsApplicable(string, this.settings.icons)) {
            this.replaceContent(content, this.createText(string, this.settings, innerRect));
        } else {
            text.setFont(this.font);
            text.setString(string);
            text.fitTo(innerRect.width, innerRect.height);
        }

        if (this.disabled) {
            this.disableContent();
        } else {
            this.enableContent();
        }
    },

    replaceContent: function (content, replacement) {
        replacement.setPosition(content.getPosition());
        replacement.setLocalZOrder(content.getLocalZOrder());
        replacement.setVisible(content.isVisible());
        replacement.setCascadeOpacityEnabledRecursively(true);
        this.addChild(replacement);
        content.removeFromParent();

        if (content === this.content) {
            this.content = replacement;
            delete this.text;
        } else {
            this.contentOff = replacement;
            delete this.textOff;
        }
    },

    setTextVariant: function (textVariant) {
        if (this.text) {
            this.font = this.workFont(textVariant);

            this.text.setFont(this.font);

            this.setString(this.text.getString());
        }

        if (this.content instanceof TextWithIcon) {
            this.font = this.workFont(textVariant);

            this.content.setFont(this.font);
        }
    },

    setType: function (type) {
        if (!type || !type.button_png) {
            type = cleverapps.styles.UI.Button.Images.button_green;
        }
        this.settings.type = type;

        this._innerUpdateBgContent();
    },

    resize: function (width, height) {
        if (width === this.width && height === this.height) {
            return;
        }

        this.setContentSize2(width, height);

        const innerRect = this.calcInnerRect();
        [this.content, this.contentOff].forEach((content) => {
            if (content) {
                content.setPosition(innerRect.x + innerRect.width / 2, innerRect.y + innerRect.height / 2);
            }
        }, this);
        this.background.setPosition(this.width / 2, this.height / 2);

        if (!this.settings.spine) {
            if (this.settings.type.keepRadius || cleverapps.styles.UI.Button.keepRadius && this.settings.type.keepRadius !== false || this.settings.keepRadius) {
                this.background.setScale(this.height / this.background.height);
                this.background.setContentSize2(this.width / this.background.scale, this.background.height);
            } else {
                this.background.setContentSize2(this.width, this.height);
            }
        }
    },

    action: function () {
        if (this.disabled) {
            return;
        }
        if (!this._isAncestorsVisible(this)) {
            return;
        }

        if (this.settings.click_effect !== undefined) {
            cleverapps.effects.fire("ui.button.click");
        }
        cleverapps.effects.fire("ui.button.haptic");

        this.settings.onClicked();
        if (this.settings.selectOnClick) {
            this.selected = !this.selected;
            this._innerUpdateBgContent();
        }
    },

    setBright: function (bright) {
        this.bright = bright;

        this._innerUpdateBgContent();
    },

    disable: function () {
        if (this.disabled) {
            return;
        }

        this.onMouseOut();
        this.setMarkVisible(false);
        this.disabled = true;
        this.clickHandler.setEnabled(false);
        this._innerUpdateBgContent();

        this.disableContent();
    },

    enable: function () {
        if (!this.disabled) {
            return;
        }

        this.disabled = false;
        this.setMarkVisible(true);
        this.clickHandler.setEnabled(true);
        this._innerUpdateBgContent();

        this.enableContent();
    },

    enableContent: function () {
        if (!this.content) {
            return;
        }

        if (this.content.enable) {
            this.content.enable();
        } else {
            cc.Base.PerformRecursive(this.content, (node) => {
                cleverapps.UI.convertToGrayScale(node, true);
            });
        }
    },

    disableContent: function () {
        const content = this.contentOff || this.content;
        if (!content) {
            return;
        }

        if (content.disable) {
            content.disable();
        } else {
            cc.Base.PerformRecursive(content, (node) => {
                cleverapps.UI.convertToGrayScale(node);
            });
        }
    },

    onMouseOver: function () {
        if (this.disabled) {
            if (this.settings.onDisableHint) {
                this.showHint(this.settings.onDisableHint);
            }
            return;
        }

        if (this.settings.onMouseOver) {
            this.settings.onMouseOver();
        } else {
            this._updateScale();

            this._innerUpdateBgContent();

            if (this.settings.hint) {
                this.showHint(this.settings.hint);
            }
        }
    },

    _updateScale: function () {
        const scaleTo = MaxInteractiveScale(this);
        const baseScale = BaseScale(this);

        if (PointerHandler.getState(this, "pressed") || PointerHandler.getState(this, "hovered")) {
            this.setScale(baseScale.x * scaleTo, baseScale.y * scaleTo);
        } else {
            this.setScale(baseScale.x, baseScale.y);
        }
    },

    onMouseOut: function () {
        if (this.disabled) {
            if (this.settings.onDisableHint) {
                this.hideHint();
            }
            return;
        }

        if (this.settings.onMouseOut) {
            this.settings.onMouseOut();
        } else {
            this._updateScale();

            this._innerUpdateBgContent();

            if (this.settings.hint) {
                this.hideHint();
            }
        }
    },

    onStatePressed: function () {
        if (this.disabled) {
            return;
        }

        this._updateScale();

        this._innerUpdateBgContent();
    },

    onStateReleased: function () {
        if (this.disabled) {
            return;
        }

        this._updateScale();

        this._innerUpdateBgContent();
    },

    _toggleContent: function (on) {
        if (this.content && this.contentOff) {
            if (on) {
                this.content.setVisible(true);
                this.contentOff.setVisible(false);
            } else {
                this.content.setVisible(false);
                this.contentOff.setVisible(true);
            }
        }
    },

    _innerUpdateBgContent: function () {
        const bright = this.bright && !this.disabled;

        if (this.settings.spine) {
            let animation = "idle";
            if (PointerHandler.getState(this, "pressed") && this.background.hasAnimation("idle_on")) {
                animation = "idle_on";
            } else if (!bright && this.background.hasAnimation("idle_off")) {
                animation = "idle_off";
            }

            this.background.setAnimation(0, animation, true);
        } else {
            if (this.background) {
                let spriteFrame = this.settings.type.button_off_png || this.settings.type.button_png;
                if (PointerHandler.getState(this, "pressed") || this.selected) {
                    spriteFrame = this.settings.type.button_on_png;
                } else if (bright) {
                    spriteFrame = this.settings.type.button_png;
                }

                this.background.setSpriteFrame(spriteFrame);
            }
            this._toggleContent(bright);
        }
    },

    _isAncestorsVisible: function (node) {
        if (node == null) {
            return true;
        }

        const parent = node.getParent();

        if (parent && !parent.isVisible()) {
            return false;
        }
        return this._isAncestorsVisible(parent);
    }
});

cleverapps.UI.Button.HINT_ACTION_TAG = 2;

cleverapps.UI.Button.TEXT_REGULAR = "regular";
cleverapps.UI.Button.TEXT_EMPHASIS = "emphasis";

cleverapps.UI.Button.WorkFont = function (textVariant) {
    if (!cleverapps.UI.Button.Fonts) {
        cleverapps.UI.Button.Fonts = {
            regular: {
                size: 0
            },
            secondary: {
                size: 0
            },
            tiny: {
                size: 0
            },
            emphasis: {
                size: 0
            },
            strict: {
                size: 0
            },
            strict_white: {
                size: 0
            },
            strict_black: {
                size: 0
            },
            strict_blue: {
                size: 0
            },
            strict_red: {
                size: 0
            }
        };
        cleverapps.overrideFonts(cleverapps.UI.Button.Fonts, {
            regular: cleverapps.styles.FONTS.BUTTON_TEXT,
            secondary: cleverapps.styles.FONTS.BUTTON_TEXT_SECONDARY,
            tiny: cleverapps.styles.FONTS.BUTTON_TEXT,
            emphasis: cleverapps.styles.FONTS.BUTTON_TEXT_RED,
            strict: cleverapps.styles.FONTS.STRICT_TEXT,
            strict_white: cleverapps.styles.FONTS.STRICT_WHITE_TEXT,
            strict_black: cleverapps.styles.FONTS.STRICT_BLACK_TEXT,
            strict_blue: cleverapps.styles.FONTS.STRICT_BLUE_TEXT,
            strict_red: cleverapps.styles.FONTS.STRICT_RED_TEXT
        });

        cleverapps.UI.Button.Fonts.tiny.stroke = cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX;
    }

    return textVariant && cleverapps.UI.Button.Fonts[textVariant] || cleverapps.UI.Button.Fonts.regular;
};

cleverapps.styles.UI.Button = {
    interactiveScale: 6,

    keepRadius: false,
    maxFontSize: 65,
    SKIP_RESOLUTION: {
        padding: {
            left: 0.3,
            right: 0.3,
            top: 0.05,
            bottom: 0.05
        }
    },
    defaultSize: 90,
    tooltipSize: {
        width: 300,
        height: 80
    },
    mark: {
        x: { align: "right", dx: 15 },
        y: { align: "top", dy: 10 }
    }
};

cleverapps.styles.UI.Button.Images = cleverapps.overrideTemplates({}, {
    button_green: {
        button_png: bundles.buttons.frames.button_png,
        button_on_png: bundles.buttons.frames.button_on_png,
        button_off_png: bundles.buttons.frames.button_disabled_png
    },

    button_blue: {
        button_png: bundles.buttons.frames.blue_button_png,
        button_on_png: bundles.buttons.frames.blue_button_on_png,
        button_off_png: bundles.buttons.frames.button_disabled_png
    },

    button_red: {
        button_png: bundles.buttons.frames.red_button,
        button_on_png: bundles.buttons.frames.red_button_on,
        button_off_png: bundles.buttons.frames.button_disabled_png
    },

    button_purple: {
        button_png: bundles.buttons.frames.purple_button_png,
        button_on_png: bundles.buttons.frames.purple_button_on_png,
        button_off_png: bundles.buttons.frames.button_disabled_png
    },

    small_button_blue: {
        button_png: bundles.buttons.frames.small_blue_button,
        button_on_png: bundles.buttons.frames.small_blue_button_on,
        button_off_png: bundles.buttons.frames.small_button_off
    },

    small_button_green: {
        button_png: bundles.buttons.frames.small_button,
        button_on_png: bundles.buttons.frames.small_button_on,
        button_off_png: bundles.buttons.frames.small_button_off
    },

    chat: {
        button_png: bundles.chat.frames.accept_button,
        button_on_png: bundles.chat.frames.accept_button_on
    },

    field_button_green: {
        button_png: bundles.buttons.frames.field_green_button,
        button_on_png: bundles.buttons.frames.field_green_button_on,
        button_off_png: bundles.buttons.frames.field_button_off
    },

    field_button_blue: {
        button_png: bundles.buttons.frames.field_blue_button,
        button_on_png: bundles.buttons.frames.field_blue_button_on,
        button_off_png: bundles.buttons.frames.field_button_off
    },

    control_button: {
        button_png: bundles.controlbuttons.frames.control_button_png,
        button_on_png: bundles.controlbuttons.frames.control_button_on_png,
        mark: {
            x: { align: "right", dx: 5 },
            y: { align: "top", dy: -5 }
        },
        SKIP_RESOLUTION: {
            padding: {
                left: 0.05,
                right: 0.05,
                top: 0.05,
                bottom: 0.05
            }
        }
    },

    back_button: {
        button_png: bundles.controlbuttons.frames.back_button_png,
        button_on_png: bundles.controlbuttons.frames.back_button_on_png,
        mark: {
            x: { align: "right", dx: 5 },
            y: { align: "top", dy: -5 }
        },
        SKIP_RESOLUTION: {
            padding: {
                left: 0.05,
                right: 0.05,
                top: 0.05,
                bottom: 0.05
            }
        }
    },

    timer_button_blue: {
        button_png: bundles.buttons.frames.timer_button,
        button_on_png: bundles.buttons.frames.timer_button_on,
        button_off_png: bundles.buttons.frames.timer_button,
        SKIP_RESOLUTION: {
            padding: {
                left: 0.15,
                right: 0.1,
                top: 0.1,
                bottom: 0.1
            }
        }
    },

    help_button: {
        button_png: bundles.help_button.frames.help_button_png,
        button_on_png: bundles.help_button.frames.help_button_on_png
    },

    help_button_light: {
        button_png: bundles.help_button.frames.help_button_light_png,
        button_on_png: bundles.help_button.frames.help_button_light_on_png
    },

    help_button_return: {
        button_png: bundles.help_button.frames.help_button_return_png,
        button_on_png: bundles.help_button.frames.help_button_return_on_png
    },

    help_button_transparent: {
        button_png: bundles.help_button.frames.help_button_transparent_png,
        button_on_png: bundles.help_button.frames.help_button_transparent_on_png
    },

    booster_button: {
        button_png: bundles.buttons.frames.booster_button_png,
        button_on_png: bundles.buttons.frames.booster_button_on_png,
        button_off_png: bundles.buttons.frames.booster_button_disabled_png
    },

    blue_round_button: {
        button_png: bundles.buttons.frames.blue_round_button,
        button_on_png: bundles.buttons.frames.blue_round_button_on
    },

    green_triangular_button: {
        button_png: bundles.buttons.frames.green_triangular_button,
        button_on_png: bundles.buttons.frames.green_triangular_button_on,
        button_off_png: bundles.buttons.frames.green_triangular_button_off
    }
});

if (cleverapps.config.debugMode) {
    cleverapps.overrideTemplates(cleverapps.styles.UI.Button.Images, {
        git: {
            button_png: bundles.git.frames.button,
            button_on_png: bundles.git.frames.button_on,
            button_off_png: bundles.git.frames.button_off,
            SKIP_RESOLUTION: {
                padding: {
                    left: 0.1,
                    right: 0.1,
                    top: 0.1,
                    bottom: 0.1
                }
            }
        },

        editor: {
            button_png: bundles.editor_buttons.frames.button,
            button_on_png: bundles.editor_buttons.frames.button_on,
            button_off_png: bundles.editor_buttons.frames.button_off,
            SKIP_RESOLUTION: {
                padding: {
                    left: 0.1,
                    right: 0.1,
                    top: 0.1,
                    bottom: 0.1
                }
            }
        },

        editor_plus: {
            button_png: bundles.admin.frames.plus_button,
            button_on_png: bundles.admin.frames.plus_button,
            button_off_png: bundles.admin.frames.plus_button
        }
    });
}
